import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { InsuranceDTO } from '@utils/interfaces';
import { useOBQuery } from '@hooks/useOBQuery';

export interface InsuranceRequest {
  organizationId: string | undefined;
}

const useGetInsuranceConfiguration = ({ organizationId }: InsuranceRequest) => {
  const url = useApiUrl(
    OBRoutes.InsuranceConfig,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##organizationId', organizationId || '');

  return useOBQuery<InsuranceDTO>(url, {
    enabled: !!url && !!organizationId,
    staleTime: 600000,
  });
};

export default useGetInsuranceConfiguration;
